import { makeTranslationHelpers } from '@/hooks/useTranslation';

const { useTranslation: useFutureTranslation, Translation: FutureTranslation } =
  makeTranslationHelpers('page.companyReport.future');

export { useFutureTranslation, FutureTranslation };
